import { useSelector } from 'react-redux';

import { MainStoreState } from 'store/main';

export function useGMapsErrored(): boolean {
  return useSelector((state: MainStoreState) => state.gMapsError.errored);
}
